<template>
	<div full-height>
		<div full-height>

			<v-toolbar flat fixed>
			    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
			    <v-toolbar-title class="white--text">Preview Settings</v-toolbar-title>
				<v-spacer></v-spacer>
				<!-- <span light-opacity-color class="mr-1 font16">Grid</span> <v-switch style="width: 0px;" hide-details v-model="gridApplicable" @change="fn_toggleGrid"></v-switch> -->
				<template v-if="$root.appVersion >= 117 && invoiceLoaded && data.templateSettings.invoiceTemplate != 101 && data.templateSettings.invoiceTemplate != 7">
					<!-- <div style="float: left;margin-right: 8px;margin-top: 6px;color: rgba(0,0,0,0.57);">Grid</div>
					<v-switch class="hide-margins" hide-details v-model="gridApplicable" @change="fn_toggleGrid"></v-switch> -->
					<v-btn icon @click="sheetMoreSettings=true"><v-icon font20>border_color</v-icon></v-btn>
				</template>
				<!-- <v-menu v-if="invoiceLoaded">
			      	<v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
			      	<v-list nopadding>
			        	<v-list-tile @click="gridClass=0">
			          		<v-list-tile-title>No Grid</v-list-tile-title>
			        	</v-list-tile>
						<v-list-tile @click="gridClass=1">
			          		<v-list-tile-title>Grid on All Sections</v-list-tile-title>
			        	</v-list-tile>
						<v-list-tile @click="gridClass=2">
			          		<v-list-tile-title>Grid on Items Table</v-list-tile-title>
			        	</v-list-tile>
			      	</v-list>
			    </v-menu> -->
			</v-toolbar>

			<div class="hasToolbar hasBigFooterWithExtention">

				<v-progress-linear height="4" nomargin indeterminate color="primary" v-if="!invoiceLoaded"></v-progress-linear>
				
				<!-- <template v-if="templateNo && templateNo!=101 && templateNo!=201"> -->
				<template v-if="!$route.query.printtype && invoiceLoaded">
					<div white-background style="overflow: scroll;white-space: nowrap;padding:12px;width: 100%;">
						<v-chip color="primary" outline v-for="(item, index) in templates" :key="index" @click="fn_bindInvoiceTemplate(item)">
					      <v-avatar v-if="item==templateNo">
					        <v-icon color="primary">done</v-icon>
					      </v-avatar>
					      Template {{item}}
					    </v-chip>
					</div>
					<div white-background style="padding: 0px 4px 12px;overflow:scroll" v-if="templateNo != 7">
						<v-layout row>
							<v-flex xs2 sm2 md2 v-for="(color, colorIndex) in colors" :key="colorIndex" style="padding: 0px 8px;">
								<div :class="{'hasborder':color=='#fff'}" style="height: 48px;width: 48px;border-radius: 50%;padding:11px;" :style="{'background':color}" @click="fn_changeColor(color)" v-ripple>
									<v-icon style="color:#000000 !important" v-if="themeColor==color">done</v-icon>
								</div>
							</v-flex>
						</v-layout>
					</div>

					<!-- <v-menu v-if="invoiceLoaded">
						<v-chip slot="activator" small>Font: Normal</v-chip>
						<v-list nopadding>
							<v-list-tile @click="gridClass=0">
								<v-list-tile-title>Normal</v-list-tile-title>
							</v-list-tile>
							<v-list-tile @click="gridClass=1">
								<v-list-tile-title>Small</v-list-tile-title>
							</v-list-tile>
							<v-list-tile @click="gridClass=2">
								<v-list-tile-title>Large</v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-menu> -->

					<v-divider></v-divider>
				</template>	

				<!-- <div style="overflow-x:scroll"> -->
				<!-- <div grey-back style="display:flex;justify-content:center"> -->
				<div>
					<!-- <div white-background style="transform-origin: 50% 24px 0px;flex:1;" :class="[hasItems ? data.transactionDetails.roundedAmount > 9999999 ? 'transform-preview-with-items-large' : 'transform-preview-with-items' : 'transform-preview']"> -->
					<div white-background :style="{'zoom':zoomPercent}" :class="{'visibility-hidden':!invoiceLoaded && templateNo!=101, 'grey-back':templateNo==7}">
						<component :is="previewTemplate" ref="ref_previewTemplate" :data="data" :preview="true" :isEditable="true" :editParty="fn_editPartyDetails" :editBusiness="fn_editBusinessProfile" :editLogo="fn_editBusinessLogo" :editTransactionFields="fn_editTransactionFields" :editPrintField="fn_editPrintFieldItem" :themeColor="themeColor" :openToggleOptions="fn_openToggleOptions" :addNote="fn_addNote" :copyFieldObj="fn_copyFieldObj" :gridClass="gridClass" :openDialogReorder="fn_openDialogReorder" :footerSection="footerSection" :gstColumnType="gstColumnType" :otherFieldsPos="otherFieldsPosition" v-if="previewTemplate && data!=null"></component>
					</div>	
				</div>
				

				<!-- handling visibility as per app verison -->
				<template v-if="$root.appVersion < 117">
					<v-footer style="height:auto;position:fixed;bottom:0;width:100%" v-if="!$route.query.printtype && invoiceLoaded">
						<v-layout grid wrap text-xs-center>
							<v-flex xs12 sm12 md12>
								<v-btn class="height48" color="primary" nomargin block no-round-borders noshadow @click="fn_saveTemplateSettings">Save Theme</v-btn>
							</v-flex>
						</v-layout>
					</v-footer>
				</template>

				<!-- handling visibility as per app verison -->
				<template v-else>
					<v-footer style="height:auto;position:fixed;bottom:0;width:100%" v-if="invoiceLoaded">
						<v-layout grid wrap text-xs-center>
							<v-flex xs6 sm6 md6>
								<v-btn class="height48" nomargin block no-round-borders noshadow @click="fn_saveTemplateSettings('default')">Reset Default</v-btn>
							</v-flex>
							<v-flex xs6 sm6 md6>
								<v-btn class="height48" color="primary" nomargin block no-round-borders noshadow @click="fn_saveTemplateSettings">Save</v-btn>
							</v-flex>
						</v-layout>
					</v-footer>
				</template>
				
			</div>
		</div>

		<dialog-toggle-options ref="ref_dialogToggleOptions"></dialog-toggle-options>
		<dialog-note ref="ref_dialogNote"></dialog-note>
		<dialog-reorder ref="ref_dialogReorder"></dialog-reorder>
		<dialog-richtext ref="ref_dialogRichText" :saveContent="fn_saveRichTextContent"></dialog-richtext>

		<v-bottom-sheet v-model="sheetMoreSettings" v-if="sheetMoreSettings">
			<v-list nopadding>
				<v-subheader class="pr-0">Format Invoice <v-spacer></v-spacer> <v-btn icon @click="sheetMoreSettings=false"><v-icon>close</v-icon></v-btn> </v-subheader>
				<v-divider></v-divider>
				<v-list-tile class="padding-right-8">
					<v-list-tile-content>
						<v-list-tile-title>Grid</v-list-tile-title>
					</v-list-tile-content>
					<v-list-tile-action>
						<v-switch class="hide-margins" hide-details v-model="gridApplicable" @change="fn_toggleGrid"></v-switch>
					</v-list-tile-action>
				</v-list-tile>

				<v-list-tile>
					<v-list-tile-content>
						<v-list-tile-title>Font Size</v-list-tile-title>
					</v-list-tile-content>
					<v-list-tile-action class="pr-3">
						<v-menu>
							<v-btn light-opacity-color slot="activator" capitalize icon>{{ $refs['ref_previewTemplate'] ? $refs['ref_previewTemplate'].invoiceFieldsObj.fontSize.value : 'Normal'  }} <v-icon>arrow_drop_down</v-icon></v-btn>
							<v-list nopadding>
								<v-list-tile v-for="(size, sizeIndex) in fontSizes" :key="sizeIndex" @click="fn_changeFontSize(size)">
									<v-list-tile-title>{{ size }}</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</v-list-tile-action>
				</v-list-tile>

					<v-list-tile>
						<v-list-tile-content>
							<v-list-tile-title>Logo Margin (Left)</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action class="pr-3" style="justify-content: right;">
							<v-btn light-opacity-color style="text-transform: lowercase;" icon @click="fn_openDialogLogoMargin">{{$refs['ref_previewTemplate'].invoiceFieldsObj.logoLeftMargin.value ? $refs['ref_previewTemplate'].invoiceFieldsObj.logoLeftMargin.value : '0'}} px<v-icon>arrow_drop_down</v-icon></v-btn>
						</v-list-tile-action>
					</v-list-tile>

					<v-list-tile>
						<v-list-tile-content>
							<v-list-tile-title>Logo Size</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action class="pr-3" style="justify-content: right;">
							<!-- <v-btn light-opacity-color style="text-transform: lowercase;" icon @click="fn_openDialogLogoMargin">{{$refs['ref_previewTemplate'].invoiceFieldsObj.logoLeftMargin.value ? $refs['ref_previewTemplate'].invoiceFieldsObj.logoLeftMargin.value : '0'}} px<v-icon>arrow_drop_down</v-icon></v-btn> -->
							<v-menu>
								<v-btn light-opacity-color slot="activator" :class="{'capitalize':$refs['ref_previewTemplate'].invoiceFieldsObj.logoSize.value != 'xl'}" icon>{{ $refs['ref_previewTemplate'] ? $refs['ref_previewTemplate'].invoiceFieldsObj.logoSize.value : 'Normal'  }} <v-icon>arrow_drop_down</v-icon></v-btn>
								<v-list nopadding>
									<v-list-tile @click="fn_changeLogoSize('Normal')">
										<v-list-tile-title>Normal</v-list-tile-title>
									</v-list-tile>
									<v-list-tile @click="fn_changeLogoSize('Large')">
										<v-list-tile-title>Large</v-list-tile-title>
									</v-list-tile>
									<v-list-tile @click="fn_changeLogoSize('XL')">
										<v-list-tile-title>XL</v-list-tile-title>
									</v-list-tile>
								</v-list>
							</v-menu>
						</v-list-tile-action>
					</v-list-tile>

					<v-list-tile class="padding-right-8">
						<v-list-tile-content>
							<v-list-tile-title>Item Name (Bold)</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<!-- <v-btn capitalize @click="fn_itemNameBold">{{ $refs['ref_previewTemplate'].invoiceFieldsObj.tableColItemName.isBold ? 'Unbold' : 'Bold' }}</v-btn> -->
							<v-switch class="hide-margins" hide-details v-model="$refs['ref_previewTemplate'].invoiceFieldsObj.tableColItemName.isBold"  @change="fn_itemNameBold"></v-switch>
							<!-- <v-checkbox :value="$refs['ref_previewTemplate'].invoiceFieldsObj.tableColItemName.isBold" @change="fn_itemNameBold"></v-checkbox> -->
						</v-list-tile-action>
					</v-list-tile>

					<v-list-tile class="padding-right-8">
						<v-list-tile-content>
							<v-list-tile-title>Auto Columns Width</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-switch class="hide-margins" hide-details v-model="$refs['ref_previewTemplate'].invoiceFieldsObj.autoColumnsWidth.value"  @change="fn_autoColumnWidth"></v-switch>
						</v-list-tile-action>
					</v-list-tile>

					<v-list-tile class="padding-right-8">
						<v-list-tile-content>
							<v-list-tile-title>Item Row Border</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-switch class="hide-margins" hide-details v-model="$refs['ref_previewTemplate'].invoiceFieldsObj.itemRowBorder.value"  @change="fn_itemRowBorder"></v-switch>
						</v-list-tile-action>
					</v-list-tile>

					<v-list-tile class="padding-right-8">
						<v-list-tile-content>
							<v-list-tile-title>Hide Payment Info</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-switch class="hide-margins" hide-details v-model="$refs['ref_previewTemplate'].invoiceFieldsObj.hidePaymentInfo.status" @change="fn_togglePaymentInfo"></v-switch>
						</v-list-tile-action>
					</v-list-tile>

					<v-list-tile class="padding-right-8">
						<v-list-tile-content>
							<v-list-tile-title>Hide Base Transaction Number</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-switch class="hide-margins" hide-details v-model="$refs['ref_previewTemplate'].invoiceFieldsObj.hideBaseTransactionNumber.status" @change="fn_toggleBaseTransactionNumber"></v-switch>
						</v-list-tile-action>
					</v-list-tile>

					<v-list-tile>
						<v-list-tile-content>
							<v-list-tile-title>Page Margin (Top)</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action class="pr-3" style="justify-content: right;">
							<v-btn light-opacity-color style="text-transform: lowercase;" icon @click="fn_openDialogPageMargin('Top')">{{$refs['ref_previewTemplate'].invoiceFieldsObj.pageTopMargin.value ? $refs['ref_previewTemplate'].invoiceFieldsObj.pageTopMargin.value : '0'}} px<v-icon>arrow_drop_down</v-icon></v-btn>
						</v-list-tile-action>
					</v-list-tile>
<!-- 
					<v-list-tile>
						<v-list-tile-content>
							<v-list-tile-title>Page Margin (Bottom)</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action class="pr-3" style="justify-content: right;">
							<v-btn light-opacity-color style="text-transform: lowercase;" icon @click="fn_openDialogPageMargin('Bottom')">{{$refs['ref_previewTemplate'].invoiceFieldsObj.pageBottomMargin.value ? $refs['ref_previewTemplate'].invoiceFieldsObj.pageBottomMargin.value : '0'}} px<v-icon>arrow_drop_down</v-icon></v-btn>
						</v-list-tile-action>
					</v-list-tile> -->

					<v-list-tile class="padding-right-8">
						<v-list-tile-content>
							<v-list-tile-title>Item Custom Field Total</v-list-tile-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-switch class="hide-margins" hide-details v-model="$refs['ref_previewTemplate'].invoiceFieldsObj.itemCustomFieldTotal.status" @change="fn_toggleItemCustomFieldTotal"></v-switch>
						</v-list-tile-action>
					</v-list-tile>

					
			</v-list>
		</v-bottom-sheet>

		<dialog-text ref="ref_dialogText" :title="$refs['ref_dialogToggleOptions'].selectedFieldItem.defaultSectionName" :textContent="$refs['ref_dialogToggleOptions'].selectedFieldItem.sectionName" v-if="$refs['ref_dialogToggleOptions'] && $refs['ref_dialogToggleOptions'].selectedFieldItem"></dialog-text>

		<dialog-logo-margin ref="ref_dialogLogoMargin"></dialog-logo-margin>

		<dialog-page-margin ref="ref_dialogPageMargin" :type="pageMarginType"></dialog-page-margin>
		
		<v-bottom-sheet v-model="partySettings" v-if="partySettings">
			<v-list nopadding>
				<v-subheader class="pr-0">Party Settings <v-spacer></v-spacer> <v-btn icon @click="partySettings=false"><v-icon>close</v-icon></v-btn> </v-subheader>
				<v-divider></v-divider>
				<v-list-tile class="padding-right-8" @click="fn_editPartyDetails('edit')">
					<v-list-tile-content>
						<v-list-tile-title>Edit Party Details</v-list-tile-title>
					</v-list-tile-content>
					<v-list-tile-action style="display: flex;justify-content: right;">
						<v-icon>keyboard_arrow_right</v-icon>
					</v-list-tile-action>
				</v-list-tile>
				
				<template v-if="$refs['ref_previewTemplate'].partyDynamicFields.items && $refs['ref_previewTemplate'].partyDynamicFields.items.length">
					<v-subheader grey-back>Party Custom Fields </v-subheader>
					<template v-for="(item, index) in $refs['ref_previewTemplate'].partyDynamicFields.items">
						<v-list-tile :key="'dynamic_' + index">
							<v-list-tile-content>
								<v-list-tile-title>{{ item.fieldName }}</v-list-tile-title>
							</v-list-tile-content>

							<v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
								<v-switch style="padding: 0 !important;flex:none" @change="fn_copyFieldObj(item)" v-model="item.status" nomargin></v-switch>
							</v-list-tile-action>
						</v-list-tile>
					</template>
				</template>
			</v-list>
		</v-bottom-sheet>
		<!-- <div id="printable" full-width>
			<component :is="printTemplate" ref="ref_printTemplate" :data="data" :themeColor="themeColor" v-if="printTemplate && data!=null"></component>
		</div> -->

		<!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->
	</div>	
</template>

<script>
const menuItem = require('../../config.js').configs.menuItem;
import dialogToggleOptions from './dialogs/dialog_toggle_options.vue'
import dialogNote from '../transactions/forms/dialogs/dialog_note.vue'
import dialogOrder from './dialogs/dialog_reorder.vue'
import dialogRichText from '../dialogs/dialog_richtext'
import dialogText from '../dialogs/dialog_text'
import dialogLogoMargin from './dialogs/dialog_logo_margin'
import dialogPageMargin from './dialogs/dialog_page_margin'
// import dialogPermission from '../dialogs/dialog_permission';

	export default{
		components:{
	    //   'dialog-permission': dialogPermission,
			'dialog-toggle-options':dialogToggleOptions,
			'dialog-note':dialogNote,
			'dialog-reorder':dialogOrder,
			'dialog-richtext':dialogRichText,
			'dialog-text':dialogText,
			'dialog-logo-margin':dialogLogoMargin,
			'dialog-page-margin':dialogPageMargin
	    },
		data(){
			return{
				data:null,
				// data:{"businessLogo":null,"paymentDetails":null,"templateSettings":{"printTemplateFields":[{"additionalData":null,"fieldId":"ebc863d6-6954-b70a-b7fa-7a22fb3168f1","fieldType":"text","name":"PO No.","orderNumber":1,"printTemplateFieldId":"e69f3f1c-7179-4cb9-9132-3d5724fe6100","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"},{"additionalData":null,"fieldId":"86723266-62de-4aac-9511-89743e6b4b7a","fieldType":"dateTime","name":"PO Date","orderNumber":2,"printTemplateFieldId":"534a94fb-7935-4bd1-a3ab-3c46f2c0158e","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"},{"additionalData":null,"fieldId":"452bc92a-fcdc-15ec-4cf7-a1ed93b2c4e2","fieldType":"choice","name":"Mode","orderNumber":3,"printTemplateFieldId":"6ab5937c-f66f-46b1-a229-4ef09c7ae8c2","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"},{"additionalData":null,"fieldId":"2fd5218f-3060-60ea-177c-d5f36d6f2233","fieldType":"accountItem","name":"Transporter Name","orderNumber":4,"printTemplateFieldId":"41b4fc33-6bef-4f87-b28b-2ec8bb346fb7","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"},{"additionalData":null,"fieldId":"b549972a-6a89-cf47-c33d-570b20422b87","fieldType":"text","name":"LR/CR/RR No.","orderNumber":5,"printTemplateFieldId":"82fabd7c-dcd2-444d-ba6d-85f901469441","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"},{"additionalData":null,"fieldId":"f64f89cd-4fa4-c201-f305-f0b367630a0f","fieldType":"text","name":"Vehicle No.","orderNumber":6,"printTemplateFieldId":"8f7e6354-d08f-4e64-8351-13d3a028e52f","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"}],"printTemplateSections":[{"addData":"{\"content\":\"\u003cp\u003e\u003cstrong class\u003d\\\"ql-size-large\\\"\u003e{{BusinessName}}\u003c/strong\u003e\u003c/p\u003e\u003cp\u003e{{BusinessAddress}}\u003c/p\u003e\u003cp\u003e{{BusinessState}}\u003c/p\u003e\"}","fieldId":"715e3806-1820-481e-929d-274839ec0c28","fieldName":"Header","printSectionId":"bd39d878-40c9-465c-a4d9-27cd2bb6917e","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","sectionName":"header"},{"addData":"{\"content\":\"\u003cp\u003e\u003cstrong\u003eNotes:\u003c/strong\u003e\u003c/p\u003e\u003cp\u003e1. Goods once sold will not be taken back.\u003c/p\u003e\u003cp\u003e2. Payment to be made by A/c payee Cheque/DD/RTGS/NEFT/IMPS in fovour of \\\" {{BusinessName}}\\\"\u003c/p\u003e\u003cp\u003e3. All dispute are subject to {{BusinessState}} Jurisdiction.\u003c/p\u003e\u003cp\u003e4. Certified that the particulars given above are true and correct.\u003c/p\u003e\"}","fieldId":"92a6d9f7-f918-416a-b3d0-243f9e75d7da","fieldName":"Terms \u0026 Condition","printSectionId":"3bd6a058-df3f-41e5-9547-c6a497f1243c","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","sectionName":"terms"},{"addData":null,"fieldId":"700d9a86-6c2e-41c8-805c-71fa7612d1c5","fieldName":"Bank Details","printSectionId":"5059b9ed-a1d4-4761-a29c-aa90604f0105","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","sectionName":"bankDetails"},{"addData":"{\"content\":\"\u003cp\u003eFor {{BusinessName}}\u003c/p\u003e\u003cp\u003e\u003cbr\u003e\u003c/p\u003e\u003cp\u003e\u003cbr\u003e\u003c/p\u003e\u003cp\u003e\u003cbr\u003e\u003c/p\u003e\u003cp\u003e\u003cbr\u003e\u003c/p\u003e\u003cp\u003e_____________________________\u003c/p\u003e\u003cp\u003eAuthorised Signatory\u003c/p\u003e\"}","fieldId":"d60e4514-3ee2-42de-9b8a-2d9ea7c0716a","fieldName":"Authorised Signatory","printSectionId":"9a824796-9adb-458d-af12-6858af9afb05","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","sectionName":"signature"},{"addData":"{\"content\":null}","fieldId":"5b9dcbb4-697f-4115-ac86-79c3cb064617","fieldName":"Bill of Supply Subtitle","printSectionId":"1582ba53-fa91-4ce2-822a-55874d860d2c","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","sectionName":"subtitle"}],"billingLabel":"Details of Receiver (Billed to)","businessLogo":true,"isHidden":false,"name":"PO No.","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","shippingLabel":"Details of Consigee (Shipped to)","templateType":0,"terms":null,"theme":"theme_light"},"transactionDetails":{"invoiceTitle":"Invoice","notes":"Being Invoice Created.","otherDetails":{"transactionFields":[{"accountLedgerId":null,"fieldDataType":"text","fieldId":"ebc863d6-6954-b70a-b7fa-7a22fb3168f1","fieldName":"PO No.","fieldValue":"123","listItemId":null,"orderNumber":"1","sectionId":"63008be4-4042-482a-b00a-7b823a1c4d18","transactionFieldId":"cb4c112d-f141-4c13-9934-b5a36f349c69","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"6db69a15-4958-4250-99ed-951f37e154de"},{"accountLedgerId":null,"fieldDataType":"dateTime","fieldId":"86723266-62de-4aac-9511-89743e6b4b7a","fieldName":"PO Date","fieldValue":"2020-05-16T00:00:00.000Z","listItemId":null,"orderNumber":"2","sectionId":"63008be4-4042-482a-b00a-7b823a1c4d18","transactionFieldId":"24d219be-e198-492c-8cd6-d24b34167c45","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"994082d6-4a13-47a3-9e35-86693aa18138"},{"accountLedgerId":null,"fieldDataType":"choice","fieldId":"452bc92a-fcdc-15ec-4cf7-a1ed93b2c4e2","fieldName":"Mode","fieldValue":"Road","listItemId":null,"orderNumber":"1","sectionId":"22d09bdd-1907-f313-0b27-61ac7ac48c14","transactionFieldId":"fa34f1b5-190f-4fc8-8b47-493cc96266b8","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"238e1c58-f7e2-14b2-9d1a-7ee40074dd6f"},{"accountLedgerId":"294664a7-623b-42c4-a506-3190f12f46f3","fieldDataType":"accountItem","fieldId":"2fd5218f-3060-60ea-177c-d5f36d6f2233","fieldName":"Transporter Name","fieldValue":"Ac Ahmed","listItemId":null,"orderNumber":"2","sectionId":"22d09bdd-1907-f313-0b27-61ac7ac48c14","transactionFieldId":"3d332c5d-9055-45c3-9445-e52f13362e8e","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"13513e10-ad45-5024-8f26-cfdc0d59a302"},{"accountLedgerId":null,"fieldDataType":"text","fieldId":"b549972a-6a89-cf47-c33d-570b20422b87","fieldName":"LR/CR/RR No.","fieldValue":"Qwe","listItemId":null,"orderNumber":"3","sectionId":"22d09bdd-1907-f313-0b27-61ac7ac48c14","transactionFieldId":"3acd7b90-1449-4779-ae3f-3c9a287dc600","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"d000e4fa-0ae0-da3d-849f-999601b80b92"},{"accountLedgerId":null,"fieldDataType":"text","fieldId":"f64f89cd-4fa4-c201-f305-f0b367630a0f","fieldName":"Vehicle No.","fieldValue":"5018","listItemId":null,"orderNumber":"4","sectionId":"22d09bdd-1907-f313-0b27-61ac7ac48c14","transactionFieldId":"05246ed9-db7c-4508-af3a-3c4d39afb197","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"5d0899a5-cfc0-b337-affb-ccea5573221e"}],"transactionSections":[{"orderNumber":1,"sectionId":"63008be4-4042-482a-b00a-7b823a1c4d18","sectionName":"Other Details","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionSectionId":"524f2a08-0a14-4cf1-a04f-c473df354099"},{"orderNumber":2,"sectionId":"22d09bdd-1907-f313-0b27-61ac7ac48c14","sectionName":"Transporter Details","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionSectionId":"d0511e9c-2b03-4f85-b9af-5fcba1386195"}]},"partyDetails":{"address":[],"gstNumber":"ABCDEABCDEABCDE","partyName":"Abinav","placeOfSupply":"Delhi","printDetails":"{\"printName\":\"Abinav\"}"},"roundedAmount":5000.0,"taxableValue":5000.0,"transactionAddOns":[],"transactionDate":"2020-05-16T15:05:49.616Z","transactionItems":[{"baseTransactionListId":"10003","baseTransactionNumber":"TI001","cols":{"addOns":[{"addOnsId":"a5f79de4-f097-2ad5-1ad7-f20fd24972bd","isGst":true,"name":"CGST","percentage":5,"value":500},{"addOnsId":"04a59876-ce17-0924-ea85-b956b46a505d","isGst":true,"name":"SGST","percentage":0.0,"value":0.0}],"baseTransactionNumber":"TI001","hsn":null,"itemName":"P1","mrp":0.0,"netAmount":5000.0,"qty":25.0,"rate":200.0,"taxableValue":5000.0,"unitId":"b4889cad-14d4-1679-e470-5789a48ce138","unitName":"Pieces"},"description":null},{"baseTransactionListId":"10003","baseTransactionNumber":"TI001","cols":{"addOns":[{"addOnsId":"a5f79de4-f097-2ad5-1ad7-f20fd24972bd","isGst":true,"name":"CGST","percentage":0.0,"value":0.0},{"addOnsId":"04a59876-ce17-0924-ea85-b956b46a505d","isGst":true,"name":"SGST","percentage":0.0,"value":0.0}],"baseTransactionNumber":"TI001","hsn":null,"itemName":"P1","mrp":0.0,"netAmount":5000.0,"qty":25.0,"rate":0,"taxableValue":5000.0,"unitId":"b4889cad-14d4-1679-e470-5789a48ce138","unitName":"Pieces"},"description":null},{"baseTransactionListId":"10003","baseTransactionNumber":"TI001","cols":{"addOns":[{"addOnsId":"a5f79de4-f097-2ad5-1ad7-f20fd24972bd","isGst":true,"name":"CGST","percentage":0.0,"value":0.0},{"addOnsId":"04a59876-ce17-0924-ea85-b956b46a505d","isGst":true,"name":"SGST","percentage":0.0,"value":0.0}],"baseTransactionNumber":"TI001","hsn":null,"itemName":"P1","mrp":0.0,"netAmount":5000.0,"qty":25.0,"rate":200.0,"taxableValue":5000.0,"unitId":"b4889cad-14d4-1679-e470-5789a48ce138","unitName":"Pieces"},"description":null},{"baseTransactionListId":"10003","baseTransactionNumber":"TI001","cols":{"addOns":[{"addOnsId":"a5f79de4-f097-2ad5-1ad7-f20fd24972bd","isGst":true,"name":"CGST","percentage":0.0,"value":0.0},{"addOnsId":"04a59876-ce17-0924-ea85-b956b46a505d","isGst":true,"name":"SGST","percentage":0.0,"value":0.0}],"baseTransactionNumber":"TI001","hsn":null,"itemName":"P1","mrp":0.0,"netAmount":5000.0,"qty":25.0,"rate":0,"taxableValue":5000.0,"unitId":"b4889cad-14d4-1679-e470-5789a48ce138","unitName":"Pieces"},"description":null}],"transactionNumber":"TI001","transactionTds":[]}},
				billingAddress:null,
				partyPhoneBilling:null,
				partyPhoneShipping:null,
				shippingAddress:null,
				otherFields:[],
				// showOtherFields:false,
				headers:[],
				items:[],
				summary:{"totalTax":0},
				addOnsTotal:[],
				gstAddOnsTotal:[],
				netTotal:0,
				isHsn:false,
				isMrp:false,
				header:{data:null, fieldId:null},
				terms:{data:null, field:null},
				bankDetails:{data:null, field:null},
				signatory:{data:null, field:null},
				subtitle:{data:null, field:null},
				// printDetails:null,
				isRef:false,
				colors:["rgba(75,119,190,0.4)", "rgba(211,211,211,0.4)", "rgba(128,128,128,0.4)", "#fff", "rgba(0,128,128,0.4)", "rgba(173,216,230,0.4)", "rgba(144,238,144,0.4)", "rgba(135,206,250,0.4)", "rgba(255,182,193,0.4)"],
				themeColor:null,
				previewTemplate:null,
				printTemplate:null,
				templateNo:1,
				templates:[1, 2, 3, 4, 5],
				backButtonPress:false,
				hasItems:false,
				zoomPercent:"100%",
				invoiceLoaded:false,
				fieldObj:{itemsObj:null, group:null},
				fieldObjTemp:[],
				
				description:{showInPrintOut:true},
				itemDescription:{showInPrintOut:true},
				brand:{showInPrintOut:false},
				category:{showInPrintOut:false},
				company:{showInPrintOut:false},
				gridClass:0,
				gridApplicable:false,
				footerSection:1,
				sheetMoreSettings:false,
				fontSizes:["Normal", "Small", "Large", "XL", "XXL"],
				gstColumnType:2,
				otherFieldsPosition:1,
				pageMarginType:null,
				partySettings:false
				// fontSize:null
			}
		},
		methods:{

			fn_openDialogRichText: function(type){
				if(type == 'bottom_note'){
					if(this.$refs['ref_previewTemplate'].invoiceFieldsObj.bottomNote.value){
						this.$refs['ref_dialogRichText'].content = this.$refs['ref_previewTemplate'].invoiceFieldsObj.bottomNote.value;
					}
					else{
						this.$refs['ref_dialogRichText'].content = "This is a Computer Generated Invoice.";
					}
				}
				this.$refs['ref_dialogRichText'].openDialogWeb();
			},

			fn_saveRichTextContent: function(type){
				if(type == 'bottom_note'){
					this.$refs['ref_previewTemplate'].invoiceFieldsObj.bottomNote.value = this.$refs['ref_dialogRichText'].content;
				}
				this.$refs['ref_dialogRichText'].closeDialogWeb();
			},

			fn_openDialogReorder: function(){
				this.$refs['ref_dialogReorder'].openDialogWeb();
			},

			fn_toggleGrid: function(val){
				if(val){
					this.gridClass = 1;
				}
				else{
					this.gridClass = 0;
				}
			},

			fn_togglePaymentInfo: function(){
				this.fn_saveConfigToLS();
				this.$refs['ref_dialogLogoMargin'].closeDialogWeb();
			},

			fn_toggleBaseTransactionNumber: function(){
				this.fn_saveConfigToLS();
				this.$refs['ref_dialogLogoMargin'].closeDialogWeb();
			},

			fn_toggleItemCustomFieldTotal: function(){
				this.fn_saveConfigToLS();
				this.$refs['ref_dialogLogoMargin'].closeDialogWeb();
			},

			fn_changeFontSize: function(size){
				// this.fontSize = size;
				this.zoomPercent = "100%";
				this.invoiceLoaded = false;
				this.$refs['ref_previewTemplate'].invoiceFieldsObj.fontSize.value = size.toLowerCase();
				this.fn_saveConfigToLS();
				this.$refs['ref_previewTemplate'].fn_init(this.templateNo, this.fn_calculateZoomPercent);
			},

			fn_changeLogoSize: function(size){
				// this.fontSize = size;
				// this.zoomPercent = "100%";
				// this.invoiceLoaded = false;
				this.$refs['ref_previewTemplate'].invoiceFieldsObj.logoSize.value = size.toLowerCase();
				this.fn_saveConfigToLS();
				// this.$refs['ref_previewTemplate'].fn_init(this.templateNo, this.fn_calculateZoomPercent);
			},

			fn_copyFieldObj: function(field){

				// hide/show taxable value column if as per gst columns visibility
				if(field.fieldId == 'tableColGST'){
					this.fieldObj.itemsObj['tableColTaxableValue'].status = field.status;

					let itemIndex = this.fieldObjTemp.findIndex(item=>item.fieldId == this.fieldObj.itemsObj['tableColTaxableValue'].fieldId);
					if(itemIndex == -1){
						this.fieldObjTemp.push(this.fieldObj.itemsObj['tableColTaxableValue']);
					}
					else{
						this.fieldObjTemp[itemIndex] = this.fieldObj.itemsObj['tableColTaxableValue'];
					}
				}

				let itemIndex = this.fieldObjTemp.findIndex(item=>item.fieldId == field.fieldId);
				if(itemIndex == -1){
					this.fieldObjTemp.push(field);
				}
				else{
					this.fieldObjTemp[itemIndex] = field;
				}
			},

			// fn_openToggleOptions: function(descriptionObj, itemDescriptionObj, brandObj, categoryObj, companyObj){
			// 	this.description.showInPrintOut = descriptionObj.showInPrintOut;
			// 	this.itemDescription.showInPrintOut = itemDescriptionObj.showInPrintOut;
			// 	this.brand.showInPrintOut = brandObj.showInPrintOut;
			// 	this.category.showInPrintOut = categoryObj.showInPrintOut;
			// 	this.company.showInPrintOut = companyObj.showInPrintOut;
			// 	this.$refs['ref_dialogToggleOptions'].openDialogWeb();
			// },

			fn_toggleItemDetails: function(key, val){
				let dataObj = {};
				dataObj.LocalKey = key;
				dataObj.LocalValue = val;
				this.$root.fn_saveLocalData(dataObj);

				if(key == 'item_description' && this.$refs['ref_previewTemplate'].description){
					this.$refs['ref_previewTemplate'].description.showInPrintOut = val;
				}
				else if(key == 'item_itemDescription' && this.$refs['ref_previewTemplate'].itemDescription){
					this.$refs['ref_previewTemplate'].itemDescription.showInPrintOut = val;
				}
				else if(key == 'item_category' && this.$refs['ref_previewTemplate'].category){
					this.$refs['ref_previewTemplate'].category.showInPrintOut = val;
				}
				else if(key == 'item_brand' && this.$refs['ref_previewTemplate'].brand){
					this.$refs['ref_previewTemplate'].brand.showInPrintOut = val;
				}
				else if(key == 'item_company' && this.$refs['ref_previewTemplate'].company){
					this.$refs['ref_previewTemplate'].company.showInPrintOut = val;
				}
			},

			fn_addNote: function (type) {
				if(type == 'print_note'){
					this.$refs['ref_dialogNote'].noteValue = this.$refs['ref_previewTemplate'].invoiceFieldsObj.printNote.value;
					this.$refs['ref_dialogNote'].openDialogWeb(type);
					setTimeout(function(){
						let noteField = document.getElementById('noteField');
						noteField.focus();
					});
				}
				else if(type == 'bottom_note'){
					// if(this.$refs['ref_previewTemplate'].invoiceFieldsObj.bottomNote.value){
					// 	this.$refs['ref_dialogNote'].noteValue = this.$refs['ref_previewTemplate'].invoiceFieldsObj.bottomNote.value;
					// }
					// else{
					// 	this.$refs['ref_dialogNote'].noteValue = "This is a Computer Generated Invoice.";
					// }
					this.fn_openDialogRichText('bottom_note');
				}
				// this.$refs['ref_dialogNote'].openDialogWeb(type);
				// setTimeout(function(){
				// 	let noteField = document.getElementById('noteField');
				// 	noteField.focus();
				// });
			},

			fn_saveNote: function (type) {
				if(type == 'print_note'){
					this.$refs['ref_previewTemplate'].invoiceFieldsObj.printNote.value = this.$refs['ref_dialogNote'].noteValue;
				}
				else if(type == 'bottom_note'){
					this.$refs['ref_previewTemplate'].invoiceFieldsObj.bottomNote.value = this.$refs['ref_dialogNote'].noteValue;
				}
				this.$refs['ref_dialogNote'].closeDialogWeb();
			},

			fn_changeColor: function(color){
				// this.printTemplate = null;
				this.themeColor = color;
                // this.$forceUpdate();
                // let elements = document.getElementsByClassName('theme-color');
                // for(let i=0;i<elements.length;i++){
                //     elements[i].style.backgroundColor = color;
                // }

                // let borderElements = document.getElementsByClassName('theme-border-color');
                // for(let i=0;i<borderElements.length;i++){
                //     borderElements[i].style.borderColor = color;
                // }
			},

			// fn_resetDefault: function(){
			// 	this.templateNo = 1;
			// 	this.themeColor = "rgba(75,119,190,0.4)";
			// 	this.fn_saveTemplateSettings('default');
			// },

			// fn_saveTemplateSettings: function(settingsType){
			// 	var self = this;
			// 	let dataObj = {};
			// 	dataObj.printTemplateId = this.data.transactionDetails.printTemplateId;
			// 	dataObj.themeColor = this.themeColor;
			// 	dataObj.invoiceTemplate = this.templateNo;
			// 	this.postData('UpdatePrintTemplate', dataObj, 
			// 		{
			// 			onSuccess: function(response){
			// 	          	console.log(response);
			// 	          	if(settingsType == "default"){
			// 	          		self.showToast("Settings updated to default");
			// 	          	}
			// 	          	else{
			// 	          		self.showToast("Settings updated");
			// 	          	}
			// 	          	self.fn_goBack();
			// 	        },
			// 	        onError: function(error){
			// 	          console.log(error);
			// 	        }
			// 		}
		    //     );
			// },

			fn_saveTemplateSettings: function(settingsType){
				var self = this;
				let dataObj = {};
				dataObj.printTemplateId = this.templateNo == 101 ?  this.data.templateSettings.printTemplateId : this.data.transactionDetails.printTemplateId;
				dataObj.themeColor = this.themeColor;
				dataObj.invoiceTemplate = this.templateNo;

				// handling visibility config if app verion above or equal to 111
                if(this.$root.appVersion >= 117){
					// processing visiblity configs
					let configItems = [];

					if(settingsType != 'default'){
						let invoiceFieldsObj = this.$refs['ref_previewTemplate'].invoiceFieldsObj;
						for(let key in invoiceFieldsObj){
							if(
								invoiceFieldsObj[key].status != invoiceFieldsObj[key].defaultStatus || 
								invoiceFieldsObj[key].value || invoiceFieldsObj[key].isBold || invoiceFieldsObj[key].autoColumnsWidth || 
								(invoiceFieldsObj[key].orderNumber && invoiceFieldsObj[key].defaultOrderNumber != invoiceFieldsObj[key].orderNumber) || 
								(invoiceFieldsObj[key].defaultSectionName && invoiceFieldsObj[key].defaultSectionName != invoiceFieldsObj[key].sectionName) || 
								(invoiceFieldsObj[key].optionFlag && invoiceFieldsObj[key].optionFlag != invoiceFieldsObj[key].defaultOptionFlag)
							){
								configItems.push(invoiceFieldsObj[key]);
							}
						}
					}
					else{
						if(this.templateNo == 101){
							dataObj.invoiceTemplate = 101;
						}
						else{
							dataObj.invoiceTemplate = 1;
							dataObj.themeColor = "rgba(211,211,211,0.4)";
						}
					}

					if(this.templateNo == 101){
						let obj = {};
						if(this.data.templateSettings.visibilityConfig){
							obj = JSON.parse(this.data.templateSettings.visibilityConfig);
						}
						obj['configItems_'+this.data.invoiceTitle] = configItems.length ? configItems : null;
						dataObj.visibilityConfig = Object.keys(obj).length ? JSON.stringify(obj) : null;
					}
					else{
						dataObj.visibilityConfig = configItems.length ? JSON.stringify(configItems) : null;
					}
				}

				this.postData('UpdatePrintTemplate', dataObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	if(settingsType == "default"){
								self.gridClass = 0;
				          		self.showToast("Settings updated to default");
				          	}
				          	else{
				          		self.showToast("Settings updated");
				          	}

							self.fn_saveGridValue();
							self.fn_saveFooterSectionStyle();
							self.fn_saveGstColumnType();
							if(self.otherFieldsPosition){
								self.fn_saveOtherFieldPosition();
							}
				          	self.fn_goBack();
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_saveGridValue: function(){
				let dataObj = {LocalKey:'invoiceGridClassValue',LocalValue:this.gridClass}
				this.$root.fn_saveLocalItem(dataObj);
			},

			fn_saveFooterSectionStyle: function(){
				let dataObj = {LocalKey:'footerSectionStyle',LocalValue:this.footerSection}
				this.$root.fn_saveLocalItem(dataObj);
			},

			fn_saveGstColumnType: function(){
				let dataObj = {LocalKey:'gstColumnType',LocalValue:this.gstColumnType}
				this.$root.fn_saveLocalItem(dataObj);
			},

			fn_saveOtherFieldPosition: function(){
				// localStorage.setItem('otherFieldsPosition', this.otherFieldsPosition);
				let dataObj = {LocalKey:'otherFieldsPosition',LocalValue:this.otherFieldsPosition}
				this.$root.fn_saveLocalItem(dataObj);
			},

			fn_calculateZoomPercent: function(headerWidth, templateNo){

				if(!headerWidth && templateNo == 7){
					this.zoomPercent = "75%";
					this.invoiceLoaded = true;
					return;
				}
				// let bodyTableElement = document.getElementById("body_template_"+this.templateNo);
				// let percentage = ((window.outerWidth - 32) / bodyTableElement.offsetWidth) * 100;
				// let headerTableElement = document.getElementById("header_template_"+this.templateNo);
				// let elementWidth = Number(headerTableElement.style.minWidth.replace("px", ''));

				let elementWidth = Number(headerWidth.replace("px", ''));
				let percentage = ((window.outerWidth - 32) / elementWidth) * 100;
				console.log(percentage);
				this.zoomPercent = percentage + '%';

				let self = this;
				setTimeout(function(){
					self.invoiceLoaded = true;
                    // self.fn_changeColor(self.data.templateSettings.themeColor);
				},300);
			},

			fn_bindInvoiceTemplate: function(templateNo){
                if(this.templateNo == templateNo){
                    return;
                }

				// storing invoice custom fields obj into temp variable
				let tempObj = null;
				if(templateNo){
					tempObj = JSON.parse(JSON.stringify(this.$refs['ref_previewTemplate'].invoiceFieldsObj));
				}

				// this.printTemplate = null;

				// if(!templateNo && localStorage.getItem("template_settings")){
				// 	let settings = JSON.parse(localStorage.getItem("template_settings"));
				// 	this.templateNo = settings.templateNo;
				// 	this.themeColor = settings.themeColor;
				// }
				// else{
				// 	this.templateNo = templateNo ? templateNo : this.$route.query.template_no;	
				// 	this.fn_saveTemplateSettingsToLocal();
				// }

				// this.templateNo = templateNo ? templateNo : this.$route.query.template_no;

				// this.printTemplate = require('./invoices/template'+this.templateNo).default;
				console.log(this.previewTemplate);
				if(!templateNo){
					this.fn_getInvoiceData();
				}
				else{
					this.templateNo = templateNo;
					if(this.$root.appVersion >= 117){
						this.previewTemplate = require('./invoices/template'+templateNo).default;
					}
					else{
						this.previewTemplate = require('./invoices_old/template'+templateNo).default;
					}
					
					let self = this;
					setTimeout(()=>{
                    	if(self.$root.appVersion >= 117){
							self.$refs['ref_previewTemplate'].fn_init(self.templateNo, null, null, self.fieldObjTemp, tempObj);
						}
						else{
							self.$refs['ref_previewTemplate'].fn_init(self.templateNo);
						}
                    },300);

                    // setTimeout(() => {
                    //     self.fn_changeColor(self.data.templateSettings.themeColor);
                    // }, 500);
				}
			},

			// fn_saveTemplateSettingsToLocal: function(){
			// 	let obj = {};
			// 	obj.themeColor = this.themeColor;
			// 	obj.templateNo = this.templateNo;
			// 	localStorage.setItem("template_settings", JSON.stringify(obj));
			// },

			fn_getInvoiceData: function(name){
	            var self = this;
	            let fName = null;
	            if(this.$route.query.printtype){
	            	fName = this.$route.query.printtype == 'ab' ? "AccountBookPrintData" : "StockJournalPrintData";
	            }
	            else{
	            	fName = "InvoiceData"
	            }

	            this.getData(fName, this.$route.query.tId, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.data = JSON.parse(response);

	                        if(localStorage.getItem("template_settings")){
	                        	let dataObj = JSON.parse(localStorage.getItem("template_settings"));
	                        	self.templateNo = dataObj.templateNo;
	                        	self.themeColor = dataObj.themeColor;
	                        }
	                        else{
	                        	self.templateNo = self.data.templateSettings.invoiceTemplate;
	                        	self.themeColor = self.data.templateSettings.themeColor;	
	                        }

                            if(self.$root.appVersion>=117){
								self.previewTemplate = require('./invoices/template'+self.templateNo).default;
							}
							else{
								self.previewTemplate = require('./invoices_old/template'+self.templateNo).default;
							}

	                        if(self.templateNo == 101){
	                        	self.invoiceLoaded = true;

	                        	// sorting as per amount types
								self.data.transactionLedgers.sort(function(a, b){
									return b.amountType - a.amountType;
								});
	                        	// sorting transaction ledgers as per order number
								self.data.transactionLedgers.sort(function(a, b){
									return a.orderNumber - b.orderNumber;
								});
	                        }
							else{
								if(self.data.transactionDetails.transactionListId == 10005){
									self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.estimatePrintTitle ? self.$root.TransactionSettings.estimatePrintTitle : 'Estimate';
								}
								else if(self.data.transactionDetails.transactionListId == 10004){
									self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.saleReturnPrintTitle ? self.$root.TransactionSettings.saleReturnPrintTitle : 'Sale Return';
								}
								else if(self.data.transactionDetails.transactionListId == 20004){
									self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.purchaseReturnPrintTitle ? self.$root.TransactionSettings.purchaseReturnPrintTitle : 'Purchase Return';
								}
								else if(self.data.transactionDetails.transactionListId == 10003 && self.$root.CurrentBusiness.GSTRegistrationStatus != 1){
									if(self.$root.TransactionSettings.invoicePrintTitle && self.$root.TransactionSettings.invoicePrintTitle != 'Default'){
										self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.invoicePrintTitle;
									}
								}
							}

	                        if(self.data.transactionDetails && self.data.transactionDetails.transactionItems && self.data.transactionDetails.transactionItems.length){
	                            // self.fn_removeZeroTaxAddons();
	                            self.hasItems = true;
	                        }
	                        else{
	                        	self.hasItems = false;
	                        }

	                        
                            // self.previewTemplate = require('./invoices/template'+self.templateNo).default;
	                        setTimeout(function(){
								// if(localStorage.getItem('otherFieldsPosition')){
								// 	self.otherFieldsPosition = localStorage.getItem('otherFieldsPosition')
								// }
	                        	self.$refs['ref_previewTemplate'].fn_init(self.templateNo, self.fn_calculateZoomPercent);
	                        },300);

							self.$root.fn_getLocalItem('invoiceGridClassValue', response=>{
								let data = JSON.parse(response);
								if(data && data.LocalValue){
									self.gridClass = data.LocalValue;
									self.gridApplicable = self.gridClass == 1 ? true : false;	
								}

								if(localStorage.getItem("template_settings")){
									let obj = JSON.parse(localStorage.getItem("template_settings"));
									self.gridApplicable = obj.gridApplicable ? obj.gridApplicable : false;
									self.gridClass = obj.gridApplicable ? 1 : 0;
								}
							});

							self.$root.fn_getLocalItem('footerSectionStyle', response=>{
								let data = JSON.parse(response);
								if(data && data.LocalValue){
									self.footerSection = data.LocalValue;
								}

								if(localStorage.getItem("template_settings")){
									let obj = JSON.parse(localStorage.getItem("template_settings"));
									self.footerSection = obj.footerSection ? Number(obj.footerSection) : 1;
								}
							})

							self.$root.fn_getLocalItem('gstColumnType', response=>{
								let data = JSON.parse(response);
								if(data && data.LocalValue){
									self.gstColumnType = Number(data.LocalValue);
								}

								if(localStorage.getItem("template_settings")){
									let obj = JSON.parse(localStorage.getItem("template_settings"));
									self.gstColumnType = obj.gstColumnType ? Number(obj.gstColumnType) : 2;
								}
							})

							self.$root.fn_getLocalItem('otherFieldsPosition', response=>{
								let data = JSON.parse(response);
								if(data && data.LocalValue){
									self.$refs['ref_previewTemplate'].otherFieldsPosition = Number(data.LocalValue);
								}

								if(localStorage.getItem("template_settings")){
									let obj = JSON.parse(localStorage.getItem("template_settings"));
									self.$refs['ref_previewTemplate'].otherFieldsPosition = obj.otherFieldsPosition ? Number(obj.otherFieldsPosition) : 1;
								}
							})
	                    }, 
	                    onError: function(error){
	                        console.log(error);           
	                    }
	                }
	            );
	        },

	        fn_removeZeroTaxAddons: function(){
	        	for(let i=0; i<this.data.transactionDetails.transactionItems.length; i++){
	        		let item = this.data.transactionDetails.transactionItems[i];
	        		item.cols.addOns = item.cols.addOns.filter(addOnsItem => {
	        			// return addOnsItem.isGst && addOnsItem.percentage != 0;
	        			return addOnsItem.percentage != 0;
	        		})
	        	}
	        },

	        fn_shareInvoice: function(type){
				let shareObj = {};
				shareObj.type = 'pdf';
				shareObj.primaryMobileNumber = this.data.transactionDetails.partyDetails.primaryMobileNumber && type == 'sharewhatsapp' ? this.data.transactionDetails.partyDetails.primaryMobileNumber : null;
				shareObj.subject = "Invoice Details";
				shareObj.email = this.data.transactionDetails.partyDetails.email ? [this.data.transactionDetails.partyDetails.email] : null ;
				shareObj.textMessage = this.$tShare('share.invoiceMessageDear', {
					party: this.data.transactionDetails.partyDetails.partyName,
					date: this.$moment(this.data.transactionDetails.transactionDate).format('DD-MMM-YYYY'),
					amount: this.$root.fixed2Decimal(this.data.transactionDetails.roundedAmount),
					businessName: this.$root.CurrentBusiness.BusinessName
				});
				this.fn_exportToPdf(shareObj);
				// this.fn_getPrintData('InvoiceData', this.displayData.transactionId, 'pdf', shareObj);
			},

			// fn_initPrintTemplate: function(type){
			// 	this.showLoading('Please wait...');
			// 	this.printTemplate = require('./invoices/template'+this.templateNo).default;
			// 	// this.$refs['ref_printTemplate'].fn_init();
			// 	let self = this;

			// 	setTimeout(function(){
			// 		self.$refs['ref_printTemplate'].fn_init();
			// 	},1000);

			// 	setTimeout(function(){
			// 		self.hideLoading();
			// 		if(type=='print'){
			// 			self.fn_printInvoice();
			// 		}
			// 		else{
		 //                self.$root.fn_checkStoragePermission(function(){
		 //                    // self.showLoading('Please wait...');
		 //                    // self.fn_allowPrintData(name, transactionId, type, shareObj);
		 //                    if(type=='sharewhatsapp'){
			// 					self.fn_shareInvoice('sharewhatsapp');
			// 				}
			// 				else{
			// 					self.fn_exportToPdf(null);
			// 				}
		 //                })
			// 		}
			// 		// else if(type=='sharewhatsapp'){
			// 		// 	self.fn_shareInvoice('sharewhatsapp');
			// 		// }
			// 		// else{
			// 		// 	self.fn_exportToPdf(null);
			// 		// }
			// 	},2000);
			// },

	        fn_printInvoice: function(){
	            // let fileName = 'print_' + this.data.transactionDetails.transactionNumber + '_' + this.data.transactionDetails.transactionDate;

	            let transactionTypeFormName = null;
	            if(this.data.transactionDetails && this.data.transactionDetails.transactionTypeFormName){
	            	transactionTypeFormName = this.data.transactionDetails.transactionTypeFormName;
	            }
	            else{
	            	transactionTypeFormName = this.data.invoiceTitle;
	            }

	            if(this.data.transactionDetails && this.data.transactionDetails.invoiceTitle == 'Tax Invoice'){
	            	transactionTypeFormName = "Invoice";
	            }
	            
	            let fileName = transactionTypeFormName.replace(/ /g,'') + '-' + this.data.transactionDetails.transactionNumber + '_' + this.$root.fn_getCurrentDateTimeString();

	            AndroidRoutingTest.print(fileName);
	   //          let self = this;
	   //          setTimeout(function(){
				// 	self.printTemplate = null;
				// },5000);
	        },

	        fn_exportToPdf: function(shareObj){
	            let self = this;

	            let transactionTypeFormName = null;
	            if(this.data.transactionDetails && this.data.transactionDetails.transactionTypeFormName){
	            	transactionTypeFormName = this.data.transactionDetails.transactionTypeFormName;
	            }
	            else{
	            	transactionTypeFormName = this.data.invoiceTitle;
	            }

	            if(this.data.transactionDetails && this.data.transactionDetails.invoiceTitle == 'Tax Invoice'){
	            	transactionTypeFormName = "Invoice";
	            }
	            
	            let fileName = transactionTypeFormName.replace(/ /g,'') + '-' + this.data.transactionDetails.transactionNumber + '_' + this.$root.fn_getCurrentDateTimeString();
	            let pageOrientation = this.$root.TransactionSettings.invoiceOrientation && !this.$root.TransactionSettings.fullPagePrint ? 'true' : 'false';
	            this.exportToPdf(fileName+'.pdf', pageOrientation, {

	              onSuccess: function(response){
	                    console.log(response);
	                    if(shareObj != undefined)
	                        self.$root.fn_share(shareObj);
	                    else
	                        self.showToast('Invoice downloaded');

	     //                setTimeout(function(){
						// 	self.printTemplate = null;
						// },5000);
	              }, 
	              onError: function(error){
	                  console.log(error);
	                  self.showToast(title + ' download failed');
	              }
	            });
	        },

			fn_editPartyDetails: function(type){
				if(type == 'edit' || !this.data.transactionDetails.partyDetails.accountFields){
					this.partySettings = false;
					this.$router.push({path:"/masters/accounts/ledgers/items/"+this.data.transactionDetails.partyDetails.partyId+"/edit"});	
				}
				else{
					this.partySettings = true;
				}
			},

			fn_editBusinessProfile: function(){
				this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit'});
			},

			fn_editBusinessLogo: function(){
				this.$router.push({path:"/settings/logo/upload", query:{preview_template:1}});
			},

			fn_editTransactionFields: function(){
				switch (Number(this.$route.query.listId)) {
					case 10001:
					case 10002:
					case 10003:
					case 10004:
					case 10005:
				    	this.$router.push({path:"/transactions/sales/"+this.$route.query.title+"/items/"+this.$route.query.tId+"/edit", query:{scroll_field:"custom_fields"}});
				        break;
				    case 20001:
					case 20002:
					case 20003:
					case 20004:
					case 20005:
				    	this.$router.push("/transactions/purchase/"+this.$route.query.title+"/items/"+this.$route.query.tId+"/edit");
				        break;
				    default:
				    	console.log("condition not matched");
				}
			},

			fn_editPrintFieldItem: function (fieldId, type) {
				if(type=="signature"){
					this.$router.push({path:"/printfield/items/"+fieldId+"/edit", query:{disableName: true, signature:1}});	
				}
				else{
					this.$router.push({path:"/printfield/items/"+fieldId+"/edit", query:{disableName: true, dialog:1}});	
				}
		    },

			// fn_openToggleOptions: function(fieldObj, group){
			// 	if(group == 'InvoiceTable' && (!this.data.transactionDetails.transactionItems || this.data.transactionDetails.transactionItems && !this.data.transactionDetails.transactionItems.length)){
			// 		return
			// 	}
			// 	else{
			// 		this.fieldObj.itemsObj = JSON.parse(JSON.stringify(fieldObj));
			// 		this.fieldObj.group = group;
			// 		this.$refs['ref_dialogToggleOptions'].openDialogWeb();
			// 	}
            // },
			fn_openToggleOptions: function(param1, param2, param3, param4, param5){
				if(this.$root.appVersion<117){
					this.description.showInPrintOut = param1.showInPrintOut;
					this.itemDescription.showInPrintOut = param2.showInPrintOut;
					this.brand.showInPrintOut = param3.showInPrintOut;
					this.category.showInPrintOut = param4.showInPrintOut;
					this.company.showInPrintOut = param5.showInPrintOut;
					this.$refs['ref_dialogToggleOptions'].openDialogWeb();
				}
				else{
					if(param2 == 'InvoiceTable' && (!this.data.transactionDetails.transactionItems || this.data.transactionDetails.transactionItems && !this.data.transactionDetails.transactionItems.length)){
						return
					}
					else{
						// param1.itemsObj = JSON.parse(JSON.stringify(param1));
						// param1.group = param2;
						// this.$refs['ref_dialogToggleOptions'].openDialogWeb();
						this.fieldObj.itemsObj = JSON.parse(JSON.stringify(param1));

						// removing product code toggle so option will not be visible in "dialog_toggle_options"
						if(this.$root.appVersion < 179){
							delete this.fieldObj.itemsObj.tableColProductCode;
						}
						
						this.fieldObj.group = param2;
						this.$refs['ref_dialogToggleOptions'].openDialogWeb();
					}
				}
            },

            fn_savePrintOptions: function(otherFieldsPosition){
                this.$refs['ref_previewTemplate'].invoiceFieldsObj = JSON.parse(JSON.stringify(this.fieldObj.itemsObj));

                if(this.fieldObj.group == 'OtherField'){
                    let otherFields = this.$refs['ref_previewTemplate'].otherFields;
                    for(let i=0; i<otherFields.length; i++){
                        for(let [key, value] of Object.entries(this.fieldObj.itemsObj)){
                            if(key == otherFields[i].fieldId){
                                otherFields[i].status = value.status;
                                break;
                            }
                        } 
                    }
                }

                this.$refs['ref_dialogToggleOptions'].closeDialogWeb();

				if(this.$refs['ref_previewTemplate'].filteredItems && this.$refs['ref_previewTemplate'].filteredItems.length){
					this.otherFieldsPosition = otherFieldsPosition;
					this.$forceUpdate();
					
					setTimeout(() => {
						// refreshing items 
						this.$refs['ref_previewTemplate'].fn_processTransactionItems(1);
						this.$refs['ref_previewTemplate'].fn_processSummary(1);

						// sorting item details as per order number
						this.$refs['ref_previewTemplate'].fn_itemDetailsArray();
					}, 100);
				}

				// refreshing template after setting change
				// this.zoomPercent = "100%";
				// this.invoiceLoaded = false;
				// this.$refs['ref_previewTemplate'].fn_init(this.templateNo, this.fn_calculateZoomPercent);

				// if(currentGstColumnType && currentGstColumnType != this.gstColumnType){
				// 	this.zoomPercent = "100%";
				// 	this.invoiceLoaded = false;
				// 	this.$refs['ref_previewTemplate'].fn_init(this.templateNo, this.fn_calculateZoomPercent);
				// }	
            },


		    fn_getBottomMenu: function () {

				var bottomMenu = {"BottomMenu": [menuItem.reset, menuItem.share]};
				let tagId = 'preview'
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='reset'){
					this.fn_reset();
				}
				else if(menuAction=='share'){
					this.fn_shareInvoice('share');
				}
				else if(menuAction=='help'){
					this.$router.push("/settings");
				}
			},

			// fn_reset: function(){
			// 	localStorage.removeItem("template_settings");
			// 	this.themeColor = this.data.templateSettings.themeColor;
			// 	this.fn_bindInvoiceTemplate();
			// },

			// fn_openPermissionDialog: function(permissionType){
		    //     this.$root.permissionType = permissionType;
		    //     this.$refs['ref_dialogPermission'].dialog_permission = true;
		    // },

		    // fn_closeDialog: function(){
		    //     this.$refs['ref_dialogPermission'].dialog_permission = false;
		    // },

			// fn_closeDialog: function(){
			// 	this.$refs['ref_dialogNote'].closeDialogWeb();
			// },

			fn_saveConfigToLS: function(){
				let obj = {};
				obj.themeColor = this.themeColor;
				obj.templateNo = this.templateNo;
				obj.gridApplicable = this.gridApplicable;
				obj.footerSection = this.footerSection;
				obj.configItems = [];
                let cobj = this.$refs['ref_previewTemplate'].invoiceFieldsObj;
                for(let key in cobj){
                    if(cobj[key].status != cobj[key].defaultStatus || cobj[key].value){
                        obj.configItems.push(cobj[key]);
                    }
                }
				localStorage.setItem("template_settings", JSON.stringify(obj));
			},

			fn_openDialogTextContent: function(){
				setTimeout(() => {
					this.$refs['ref_dialogText'].openDialogWeb();
				}, 100);
			},

			fn_saveText: function(text){
				this.$refs['ref_dialogToggleOptions'].selectedFieldItem.sectionName = text;
				this.$refs['ref_dialogText'].closeDialogWeb();
			},

			fn_openDialogLogoMargin: function(){
				this.$refs['ref_dialogLogoMargin'].openDialogWeb();
			},

			fn_changeMargin: function(margin){
				// this.invoiceLoaded = false;
				this.$refs['ref_previewTemplate'].invoiceFieldsObj.logoLeftMargin.value = margin ? margin : 0;
				this.fn_saveConfigToLS();
				this.$refs['ref_dialogLogoMargin'].closeDialogWeb();
				// this.$refs['ref_previewTemplate'].fn_init(this.templateNo, this.fn_calculateZoomPercent);
			},

			fn_openDialogPageMargin: function(type){
				this.pageMarginType = type;
				this.$refs['ref_dialogPageMargin'].openDialogWeb();
			},

			fn_changePageMargin: function(margin){
				if(this.pageMarginType == 'Top'){
					this.$refs['ref_previewTemplate'].invoiceFieldsObj.pageTopMargin.value = margin ? margin : 0;
				}
				else if(this.pageMarginType == 'Bottom'){
					this.$refs['ref_previewTemplate'].invoiceFieldsObj.pageBottomMargin.value = margin ? margin : 0;
				}
				
				this.fn_saveConfigToLS();
				this.$refs['ref_dialogPageMargin'].closeDialogWeb();
			},

			fn_itemNameBold: function(){
				// this.$refs['ref_previewTemplate'].invoiceFieldsObj.tableColItemName.isBold = !this.$refs['ref_previewTemplate'].invoiceFieldsObj.tableColItemName.isBold;
				this.fn_saveConfigToLS();
				this.$refs['ref_dialogLogoMargin'].closeDialogWeb();
			},

			fn_autoColumnWidth: function(){
				this.fn_saveConfigToLS();
				this.$refs['ref_dialogLogoMargin'].closeDialogWeb();
			},

			fn_itemRowBorder: function(){
				this.fn_saveConfigToLS();
				this.$refs['ref_dialogLogoMargin'].closeDialogWeb();
			},

		    fn_goBack: function(){
		    	this.backButtonPress = true;
		    	this.$router.go(-1);
		    }
		},
		mounted(){
			// window.js_globals.fn_openPermissionDialog = this.fn_openPermissionDialog;
			window.js_globals.fn_onBackPress = this.fn_goBack;
			this.fn_bindInvoiceTemplate()
		},
		beforeRouteLeave(to, from, next){
	      	// if(this.$refs['ref_dialogPermission'].dialog_permission){
	        // 	this.$refs['ref_dialogPermission'].closeDialogWeb();
	        // 	next(false);
	      	// }
			if(this.$refs['ref_dialogText'] && this.$refs['ref_dialogText'].dialog_text){
	        	this.$refs['ref_dialogText'].closeDialogWeb();
	        	next(false);
	      	}
			else if(this.$refs['ref_dialogToggleOptions'] && this.$refs['ref_dialogToggleOptions'].dialog_toggle_options){
				if(this.$refs['ref_dialogToggleOptions'].reorder){
					this.$refs['ref_dialogToggleOptions'].reorder = false;
				}
				else{
					this.$refs['ref_dialogToggleOptions'].closeDialogWeb();
				}	        	
	        	next(false);
	      	}
			else if(this.$refs['ref_dialogNote'].dialog_note){
	        	this.$refs['ref_dialogNote'].closeDialogWeb();
	        	next(false);
	      	}
			else if(this.$refs['ref_dialogReorder'].dialog_reorder){
	        	this.$refs['ref_dialogReorder'].closeDialogWeb();
	        	next(false);
	      	}
			else if(this.$refs['ref_dialogRichText'].dialog_richtext){
	        	this.$refs['ref_dialogRichText'].closeDialogWeb();
	        	next(false);
	      	}
			else if(this.$refs['ref_dialogLogoMargin'].dialog_logo_margin){
	        	this.$refs['ref_dialogLogoMargin'].closeDialogWeb();
	        	next(false);
	      	}
			else if(this.sheetMoreSettings){
	        	this.sheetMoreSettings = false;
	        	next(false);
	      	}
			else if(this.partySettings){
	        	this.partySettings = false;
	        	next(false);
	      	}
	      	else if(this.backButtonPress){
				localStorage.removeItem("template_settings");
	      		next();
	      	}
			else{
	      		this.fn_saveConfigToLS();
	        	next();
	      	}
	      	// else{
	      	// 	let obj = {};
			// 	obj.themeColor = this.themeColor;
			// 	obj.templateNo = this.templateNo;
			// 	localStorage.setItem("template_settings", JSON.stringify(obj));
	        // 	next();
	      	// }
	    },
	    beforeRouteEnter(to, from, next){
	      	next(vm => {
	      		if(from.name == 'invoicePreview'){
	      			localStorage.removeItem("template_settings");
	      		}
		  	});
	    },
		// computed:{
		// 	filteredItems: function(){
		// 		let transactionGroups = [];

		// 		for(let i in this.items){

		// 			if(this.items[i].baseTransactionNumber != this.data.transactionDetails.transactionNumber){
		// 				this.isRef = true;
		// 			}

		// 	        let itemIndex = transactionGroups.findIndex(transItem => transItem.baseTransactionNumber==this.items[i].baseTransactionNumber);

		// 	        if(itemIndex!=-1){
		// 	            transactionGroups[itemIndex].items.push(this.items[i]);
		// 	        }
		// 	        else{
		// 	            let obj = {};
		// 	            obj.baseTransactionNumber = this.items[i].baseTransactionNumber;
		// 	            obj.items = []
		// 	            obj.items.push(this.items[i]);
		// 	            transactionGroups.push(obj);
		// 	        }
		// 	    }

		// 	    console.log(JSON.stringify(transactionGroups));

		// 	    return transactionGroups;
		// 	}
		// }
	}
</script>


// WEBPACK FOOTER //
// src/components/invoice_templates/invoice_template_preview.vue